module.exports = __webpack_public_path__ + "static/img/pro6.79d5c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro6.png
// module id = ZFqr
// module chunks = 0